module.exports = __webpack_public_path__ + "img/advantage1@2x.388c6e9f.png";